// LUCKY DUCKY · PHASE 2 · Wager state module
// Source of truth: spec/verified_paytable.json → wagers_credits
// Denomination is 1¢, so credits map 1:1 to cents.
import verified from '../spec/verified_paytable.json';

export const DENOM_CENTS = verified.denomination_cents;
export const WAGER_KEYS  = ['PLAY_1X', 'PLAY_2X', 'PLAY_3X', 'PLAY_120', 'PLAY_180', 'PLAY_240', 'PLAY_300', 'PLAY_400', 'MAX_PLAY'];
export const WAGER_CREDITS = verified.wagers_credits;

export const WAGER_LABELS = {
  PLAY_1X:  'PLAY 1×',
  PLAY_2X:  'PLAY 2×',
  PLAY_3X:  'PLAY 3×',
  PLAY_120: '$1.20',
  PLAY_180: '$1.80',
  PLAY_240: '$2.40',
  PLAY_300: '$3.00',
  PLAY_400: '$4.00',
  MAX_PLAY: 'MAX PLAY',
};

// Convert credits (1¢ each) → dollars for HUD display.
export const creditsToDollars = (c) => (c * DENOM_CENTS) / 100;
export const dollarsFromWager = (k) => creditsToDollars(WAGER_CREDITS[k] || 0);

// LOCKED: MAX PLAY is a separate wager state.  Any side effects beyond the
// verified 500-credit/$5 wager remain NEEDS_VERIFICATION and must NOT be
// silently applied here.
export const MAX_PLAY_SIDE_EFFECTS = 'NEEDS_VERIFICATION';
